import React from 'react';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';

const ConfirmationDialog = (props) => {
    let actions = [
      <FlatButton label="Cancel" primary={true} onClick={props.onCancel} />,
      <FlatButton label="Submit" primary={true} onClick={props.onSubmit} />,
    ];
  return (
    <Dialog title={props.title} autoDetectWindowHeight={true} actions={actions} modal={true} open={ props.showDialog }>
     {props.text}
    </Dialog>
  );
};

export default ConfirmationDialog;



// WEBPACK FOOTER //
// ./src/scripts/components/lib/modals/ConfirmationDialog.js